import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ls from 'localstorage-slim';

function TaxPayer() {
  const subDomain = ls.get('subDomain');

  let navigate = useNavigate();

  const [taxpayer, setTaxpayer] = useState(null);
  const [taxpayerData, setTaxpayerData] = useState([]);

  const handleSelectTaxPayer = () => {
    ls.set('taxpayer_id', taxpayer);
    navigate('/home/welcome', { state: { showToast: true } });
  };

  const handleChangeTaxpayer = event => {
    setTaxpayer(+event.target.value);
  };

  useEffect(() => {
    axios
      .get(`${subDomain}${process.env.REACT_APP_DJANGO_BASEURL}/auth/current_user_taxpayers`, {
        headers: { Authorization: `Bearer ${ls.get('access')}` },
      })
      .then(response => {
        ls.get('taxpayer_id')
          ? setTaxpayerData(response.data.filter(taxpayer => taxpayer.id !== ls.get('taxpayer_id')))
          : setTaxpayerData(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <div className='container'>
        <div className='d-flex justify-content-center my-5'>
          <div className='row my-5'>
            <div className='card mx-auto my-5 shadow'>
              <div className='card-body'>
                <div className='row mt-2 mb-4'>
                  <span className='d-block my-2 fs-4'>Please select taxpayer</span>
                </div>
                <div className='row'>
                  <select
                    className='form-select d-block mb-5 w-75 mx-auto py-2'
                    onChange={handleChangeTaxpayer}>
                    <option value=''>Select a taxpayer</option>
                    {taxpayerData.map(taxpayer => (
                      <option key={taxpayer.id} value={taxpayer.id}>
                        {taxpayer.company_name_ar}
                      </option>
                    ))}
                  </select>
                </div>
                <div className='row mt-5'>
                  <div
                    className='btn btn-primary mx-auto w-50 text-nowrap'
                    onClick={handleSelectTaxPayer}>
                    Select Taxpayer
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TaxPayer;
